import React, { useContext } from "react";
import { Card, CardContent, Box, Grid, Typography } from "@mui/material";
import OrderSummaryItem from "./OrderSummaryItem"; // Import the new component
import { FONT_FAMILY } from "../../config/themeConstants"; // Import FONT_FAMILY
import { IMAGE_BASE_URL } from "../../config/constants"; // Import API_BASE_URL
const OrderSummeryShort = ({ cartItems, comboCartObject }) => {
  let index = 0;

  return (
    <Grid id="ordersshort">
    {Object.entries(cartItems).map(([inventoryid, item]) => (
     ( // Conditional rendering based on item.quantity
        <Box sx={{ mb: 2, position: "relative" }} key={inventoryid}>
          <Card elevation={3} sx={{ borderRadius: 2, padding: "0px" }}>
            {/* Circular Badge for Index */}
            <Box
              sx={{
                position: "absolute",
                top: -10,
                left: -10,
                width: 20,
                height: 20,
                backgroundColor: "teal",
                color: "white",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {++index}
            </Box>
            <CardContent sx={{ padding: "10px 10px 0px 20px" }}>
              <Grid container spacing={0} alignItems="center">
                {/* First Column: Combo Name and Item Labels */}
                <Grid xs={12}>
                  <Typography
                    sx={{
                      fontFamily: FONT_FAMILY,
                      fontSize: "18px",
                      fontWeight: "bold",
                      marginBottom: "10px",
                    }}
                  >
                    {item.label}
                  </Typography>
                </Grid>
                {/* Third Column: Image */}
                <Grid xs={4}>
                  <Box
                    component="img"
                    src={IMAGE_BASE_URL + item.image}
                    alt={item.label}
                    sx={{
                      width: "75px",
                      height: "75px",
                      objectFit: "cover",
                      borderRadius: 1,
                      border: "1px solid #ddd",
                    }}
                  />
                </Grid>
                <Grid xs={8}>
                  <Typography
                    sx={{
                      fontFamily: FONT_FAMILY,
                      fontSize: "18px",
                    }}
                  >
                    Selling price: ₹{item.price}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: FONT_FAMILY,
                      fontSize: "18px",
                    }}
                  >
                    Quantity: {item.quantity}
                  </Typography>
                  <Box sx={{ textAlign: "right" }}>
                    {" "}
                    {/* Wrap the Total in a Box for alignment */}
                    <Typography
                      sx={{
                        fontFamily: FONT_FAMILY,
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "success.main",
                      }}
                    >
                      Total: ₹
                      {(
                        parseFloat(item.price) * parseFloat(item.quantity)
                      ).toFixed(2)}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      )
    ))}
  </Grid>  
  );
};

export default OrderSummeryShort;
